<template>
  <div ref="ball" class="ball"
    @mouseoverr="showChild"
    @mouseleaver="hideChild"
    @click="toggleChild"
    :class="[dotClassname, config.className]"
    
    >
    <div class="central" style>
      <div class="label" v-html="config.ball_label"></div>
      <div 
        class="child" 
        v-for="(item, index) in children"
        @click.stop="onChildClick(item)"
        :style="{transform: 'rotate(0) ' + translate(item) }" 
        :key="index">
          <div class="wave"></div>
          <div class="wave2"></div>
          <div class="child-ball"></div>
          <div class="child-icon"><i class="las" :class="['la-' + item.ball_icon]"></i></div>
          <div class="child-label">{{item.ball_label}}</div>
        </div>
    </div>
    <div class="label-hidden" v-html="config.ball_label"></div>
    <div class="wave"></div>
    <div class="wave2"></div>
  </div>
</template>

<script>
import LFModal from '@/lib/lfmodal.js';
import Store from '@/store';

import BallsModal from '@/components/content/BallsModal';

export default {

  props: {
    config: {
      default: {}
    },
  },

  data() {
    return {
      dotClassname: {},
      translateVectors: [],
      children: [],
      active: false,
    }
  },

  methods: {
    onChildClick(item){
      Store.commit('modal/setComponent', BallsModal);
      Store.commit('modal/setContent', {
        item,
        section: this.config.label,
      });
      LFModal.show({className: 'modal-fullwidth'});
    },

    translate(item){
      if(item.vector){
        return `rotate(0) translate(${item.vector[0]}px,${item.vector[1]}px)`;
      } else {
        return `rotate(45deg) translate(0, 0)`;
      }
    },

    toggleChild(){
      this.active ? this.hideChild() : this.showChild();
      if(!this.active){
        this.$emit('itemHidden', this.config);
      }
    },

    showChild(){
      this.$emit('itemShown', this.config);
      this.dotClassname.active = this.active = true;
      this.children = this.children.map(v => {
        v.vector = v._vector;
        return v;
      });
    },

    hideChild(){
      this.dotClassname.active = this.active = false;
      this.children = this.children.map(v => {
        v.vector = null;
        return v;
      });
    },

    alignChild(){
      const ballRadio = 40;
      const offset = 20;
      const dist = (this.$refs.ball.clientWidth / 2) + ballRadio + offset;
      const step = 360 / this.config.children.length;

      let i = 0;
      this.children = this.config.children.map(v => {
        const rad = (i + 45) * Math.PI / 180; // with 45 deg offset;
        v._vector = [dist * Math.cos(rad), dist * Math.sin(rad)];
        i += step;
        return v;
      });
    }
  },

  mounted() {
    this.alignChild();
  },

  created(){
    this.dotClassname[this.config.color] = true;
    this.dotClassname.active = false;
    this.children = this.config.children.map(v => {
      v.vector = null;
      return v;
    });

    window.addEventListener('resize', this.alignChild);
  }
}
</script>
